/**
 * 新增sessionStorage
 */
export const setStore = (name, content) => {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.sessionStorage.setItem(name, content);
}

/**
 * 獲取sessionStorage
 */
export const getStore = name => {
  if (!name) return;
  return window.sessionStorage.getItem(name);
}

/**
 * 删除sessionStorage
 */
export const removeStore = name => {
  if (!name) return;
  window.sessionStorage.removeItem(name);
}
/**
 * 取得 MenuIndex
 */
export const getMenuIndex = data => {
  const Menu = JSON.parse(sessionStorage.getItem("RoleAuthorizeMenu"));
  if (Menu) {
    for (let i = 0; i < Menu.length; i++) {
      if (Menu[i].child) {
        for (let j = 0; j < Menu[i].child.length; j++) {
          if (Menu[i].child[j].child) {
            for (let k = 0; k < Menu[i].child[j].child.length; k++) {
              if (Menu[i].child[j].child[k].href == data) return i;
            }
          } else {
            if (Menu[i].child[j].href == data) return i;
          }
        }
      } else {
        if (Menu[i].href == data) return i;
      }
    }
  }
  return null;
}

/**
 * 取得選單資訊
 */
 export const getMenu = data => {
  const Menu = JSON.parse(sessionStorage.getItem("RoleAuthorizeMenu"));
  if (Menu) {
    for (let i = 0; i < Menu.length; i++) {
      if (Menu[i].child) {
        for (let j = 0; j < Menu[i].child.length; j++) {
          if (Menu[i].child[j].child) {
            for (let k = 0; k < Menu[i].child[j].child.length; k++) {
              if (Menu[i].child[j].child[k].href == data) return { menuIndex: i, menuName: Menu[i].child[j].child[k].txt };
            }
          } else {
            if (Menu[i].child[j].href == data)  return { menuIndex: i, menuName: Menu[i].child[j].txt };
          }
        }
      } else {
        if (Menu[i].href == data)  return { menuIndex: i, menuName: Menu[i].txt };
      }
    }
  }
  return null;
}

//驗證身份證
export function ChkIdNo(value) {
  var a = new Array('A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'X', 'Y', 'W', 'Z', 'I', 'O');
  var b = new Array(1, 9, 8, 7, 6, 5, 4, 3, 2, 1);
  var c = new Array(2);
  var d;
  var e;
  var f;
  var g = 0;
  var h = /^[a-z](1|2)\d{8}$/i;
  if (value.trim() == "") {
    return true;
  }
  if (value.search(h) == -1) {
    return false;
  }
  else {
    d = value.charAt(0).toUpperCase();
    f = value.charAt(9);
  }
  for (var i = 0; i < 26; i++) {
    if (d == a[i])//a==a
    {
      e = i + 10; //10
      c[0] = Math.floor(e / 10); //1
      c[1] = e - (c[0] * 10); //10-(1*10)
      break;
    }
  }
  for (var i = 0; i < b.length; i++) {
    if (i < 2) {
      g += c[i] * b[i];
    }
    else {
      g += parseInt(value.charAt(i - 1)) * b[i];
    }
  }

  if ((parseInt(g) + parseInt(f)) % 10 == 0) {
    return true;
  }
  else {
    return false;
  }
}
//驗證身份證& 居留證
export function ChkIDorRCNumber(value) {
  // var a = new Array('A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z');
  // // 原身分證英文字應轉換為10~33，這裡直接作個位數*9+10
  // var b = new Array(1, 10, 19, 28, 37, 46, 55, 64, 39, 73, 82, 2, 11, 20, 48, 29, 38, 47, 56, 65, 74, 83, 21, 3, 12, 30);
  // // 原居留證第二碼英文字應轉換為10~33，並僅取個位數*8，這裡直接取[(個位數*8) mod 10]
  // var c = new Array(0, 8, 6, 4, 2, 0, 8, 6, 2, 4, 2, 0, 8, 6, 0, 4, 2, 0, 8, 6, 4, 2, 6, 0, 8, 4);
  var a = new Array('A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'X', 'Y', 'W', 'Z', 'I', 'O');
  var b = new Array(1, 9, 8, 7, 6, 5, 4, 3, 2, 1);
  var c = new Array(2);
  var d;
  var e;
  var f;
  var g = 0;
  var h = /^[a-z](1|2)\d{8}$/i;
  var z = false;
  if (value.trim() == "") {
    return true;
  }
  if (value.search(h) == -1) {
    //return false;
    z = true;
  }
  else {
    d = value.charAt(0).toUpperCase();
    f = value.charAt(9);
  }
  for (var i = 0; i < 26; i++) {
    if (d == a[i])//a==a
    {
      e = i + 10; //10
      c[0] = Math.floor(e / 10); //1
      c[1] = e - (c[0] * 10); //10-(1*10)
      break;
    }
  }
  for (var i = 0; i < b.length; i++) {
    if (i < 2) {
      g += c[i] * b[i];
    }
    else {
      g += parseInt(value.charAt(i - 1)) * b[i];
    }
  }

  if ((parseInt(g) + parseInt(f)) % 10 == 0) {
    return true;
  }
  else {
    //return false;
    z = true;
  }
  if (z) {
    /* 檢查統一證(居留證)編號 */
    return isLiveID(value);
  }
}
/* 檢查統一證(舊制居留證)編號 */
export function isLiveID(value) {
  var z = false;
  if (! /^[a-zA-Z]{1}[a-dA-D]{1}[0-9]{8}$/.test(value)) {
    //return false;
    z = true;
  }
  else {
    var id_ = value.toUpperCase();
    var sum = 0;
    var str1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    var str2 = "1011121314151617341819202122352324252627282932303133";
    var t1 = str2.substr(str1.indexOf(id_.substr(0, 1)) * 2, 2);
    var t2 = str2.substr(str1.indexOf(id_.substr(1, 1)) * 2, 2);
    var t10_= 0;
    sum = t1.substr(0, 1) * 1 + t1.substr(1, 1) * 9;
    sum += (t2 % 10) * 8;

    var t10 = id_.substr(9, 1);

    for (var t_i = 3; t_i <= 9; t_i++) {
      sum += id_.substr(t_i - 1, 1) * (10 - t_i);
    }
    if (sum % 10 == 0) {
      t10_ = 0;
    } else {
      t10_ = 10 - (sum % 10);
    }

    if (t10_ == t10) {
      return true;
    } else {
      z = true;
    }
  }
  if (z) {
    /* 檢查統一證(居留證)編號新制 */
    return isLiveIDNew(value);
  }

}
/* 檢查統一證(新制居留證)編號 */
export function isLiveIDNew(value) {
  var a = new Array('A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'X', 'Y', 'W', 'Z', 'I', 'O');
  var b = new Array(1, 9, 8, 7, 6, 5, 4, 3, 2, 1);
  var c = new Array(2);
  var d;
  var e;
  var f;
  var g = 0;
  var h = /^[a-z](8|9)\d{8}$/i;
  if (value.trim() == "") {
    return true;
  }
  if (value.search(h) == -1) {
    return false;
  }
  else {
    d = value.charAt(0).toUpperCase();
    f = value.charAt(9);
  }
  for (var i = 0; i < 26; i++) {
    if (d == a[i])//a==a
    {
      e = i + 10; //10
      c[0] = Math.floor(e / 10); //1
      c[1] = e - (c[0] * 10); //10-(1*10)
      break;
    }
  }
  for (var i = 0; i < b.length; i++) {
    if (i < 2) {
      g += c[i] * b[i];
    }
    else {
      g += parseInt(value.charAt(i - 1)) * b[i];
    }
  }

  if ((parseInt(g) + parseInt(f)) % 10 == 0) {
    return true;
  }
  else {
    return false;
  }
}
//驗證Email
export function ChkEmail(value){
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(value).toLowerCase());
}

//登出
export function logOut(serviceUnit, vm){
  switch (serviceUnit) {
    case "CY":
      sessionStorage.removeItem("LoginInfo");
      sessionStorage.removeItem("Session_GovCode");
      localStorage.removeItem("fontSize");
      vm.$router.push({path: '/BackStage/Cy/Login'});
      break;
    case "PDIS":
      sessionStorage.removeItem("LoginInfo");
      sessionStorage.removeItem("Session_GovCode");
      localStorage.removeItem("fontSize");
      vm.$router.push({path: '/BackStage/PDIS/Login'});
      break;
    }
}
